import React, {useEffect, useRef, useState} from "react";
import "../Lists/ListStyles.css";
import {useTranslation} from "react-i18next";

interface CustomProps {
  edit: () => void,
  removeDepartment: () => void
}

export default function ActionDotsUpdateDepartments({
  edit,
  removeDepartment
}:CustomProps) {
  const { t } = useTranslation();

  const [menuListOpen, setMenuListOpen] = useState(false);

  // Detect click outside for close menu

  const branchesActions = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (event:any) => {
      if (!branchesActions.current?.contains(event.target as Node)) {
        setMenuListOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const handleClick = (func:string) => {
    setMenuListOpen(false);
    if (func === "edit") {
      edit();
    } else if (func === "delete") {
      removeDepartment();
    }
  };

  return(
    <div ref={branchesActions} className="action_dots_container">
      <div
        onClick={() => setMenuListOpen(!menuListOpen)}
        className="action_container" style={{width: "30px"}}>
        <div className="action_dot" />
        <div className="action_dot" />
        <div className="action_dot" />
      </div>
      {menuListOpen && (
        <div className="table_menu shadow" style={{
          left: "0"
        }}>
          <div
            onClick={() => handleClick("edit")}
            className="table_menu_item row">
            <p>{t("dashboard.general.dep_branch.update_department")}</p>
          </div>
          <div
            onClick={() => handleClick("delete")}
            className="table_menu_item row">
            <p>{t("dashboard.general.dep_branch.remove_department")}</p>
          </div>
        </div>
      )}
    </div>
  );
}
